import { useTranslation } from "react-i18next";
import formatNumber from "../../../common/helpers/formatNumber";
import { isVatRatePercentZero, VatPercentCategory } from "../utils";

interface Props {
  vatSum: VatPercentCategory;
}

const InvoiceVatLabelString = ({ vatSum }: Props) => {
  const { t } = useTranslation("invoices");

  return (
    <>
      {t("vatAmount")} {formatNumber(vatSum.vatRatePercent)}
      {isVatRatePercentZero(vatSum.vatRatePercent)
        ? ` % ${vatSum.vatCode}:`
        : ` ${t("percentSeparator")}`}
    </>
  );
};

export default InvoiceVatLabelString;
